// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.disabled{opacity:.4;background-color:gray}`, "",{"version":3,"sources":["webpack://./features/ctd/annotate/components/Table.css"],"names":[],"mappings":"AAAA,UACI,UAAA,CACA,qBAAA","sourcesContent":[".disabled {\n    opacity: 0.4;\n    background-color: grey;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
